/* eslint-disable max-len */
const brandstore = require('./brandstore.json');

/**
 * @typedef {Object} Brand
 * No additional properties allowed.
 * @property {number} documentBrandLevelTypeID
 * @property {number} onTrackBrandLevelTypeID
 * @property {number} onlineBrandLevelTypeID
 * @property {string} sPVName
 * @property {string} sPVACN
 * @property {number} ultracsBranchID
 * @property {number} partyRoleID
 */

/**
 * @typedef {Object} PreSettlement
 * No additional properties allowed.
 * @property {string} australianPhone
 * @property {string|null} internationalPhone
 * @property {string} emailAddress - Must be a valid email format.
 * @property {string} signatureImage
 * @property {string} signatureTextLine1
 * @property {string} signatureTextLine2
 * @property {number} footerAlignmentTypeID
 * @property {string} footerLine1Column1
 * @property {string} footerLine2Column1
 * @property {string} footerLine3Column1
 * @property {string} footerLine4Column1
 * @property {string} footerLine5Column1
 * @property {string} footerLine1Column2
 * @property {string} footerLine2Column2
 * @property {string} footerLine3Column2
 * @property {string} footerLine4Column2
 * @property {string} footerLine5Column2
 */

/**
 * @typedef {Object} PostSettlement
 * No additional properties allowed.
 * @property {string} australianPhone
 * @property {string|null} internationalPhone
 * @property {string} emailAddress - Must be a valid email format.
 * @property {string} signatureImage
 * @property {string} signatureTextLine1
 * @property {string} signatureTextLine2
 * @property {number} footerAlignmentTypeID
 * @property {string} footerLine1Column1
 * @property {string} footerLine2Column1
 * @property {string} footerLine3Column1
 * @property {string} footerLine4Column1
 * @property {string} footerLine5Column1
 * @property {string|null} footerLine2Column2
 * @property {string|null} footerLine3Column2
 * @property {string|null} footerLine4Column2
 * @property {string|null} footerLine5Column2
 */

/**
 * @typedef {Object} DocumentsBranding
 * No additional properties allowed.
 * @property {string} headerLogoId
 * @property {number} headerAlignmentTypeId
 * @property {string|null} preSettlementSignature
 * @property {PreSettlement} preSettlement
 * @property {PostSettlement} postSettlement
 */

/**
 * @typedef {Object} CssFile
 * No additional properties allowed.
 * @property {string} filename
 * @property {string} data - Base64 encoded string
 */

/**
 * @typedef {Object} OnlineBranding
 * No additional properties allowed.
 * @property {string} onlineServicesUrl
 * @property {string} onlineHeaderLogoId
 * @property {CssFile} cssFile
 */

/**
 * @typedef {Object} OnTrackBranding
 * No additional properties allowed.
 * @property {string} onTrackUrl
 * @property {string} onTrackHeaderLogoId
 * @property {CssFile} cssFile
 */

/**
 * Branding schema for various categories
 * No additional properties allowed.
 * @typedef {Object} Brandstore
 * @property {Brand} brand
 * @property {DocumentsBranding} documentsBranding
 * @property {OnlineBranding} onlineBranding
 * @property {OnTrackBranding} onTrackBranding
 */

/**
 * Sale related validation schemas for collateral
 * @module schemas/client
 * @property {Brandstore} brandstore
 */
module.exports = {
  brandstore,
};
